// @need-translate
import {t} from '../../../common/getTranslations';
import {showSimpleDialog} from '../../../dialog/simpleDialogHandler';
import {closeCreditRefund} from '../../credit-refund/request/util/closeCreditRefund';

export function showAgeUnder14Dialog({isMobile}: {isMobile: boolean}) {
  showSimpleDialog({
    title: t('more_customer_cash_refund_under14_popup'),
    isMobile,
    onClose: closeCreditRefund,
    okButton: {
      text: t('common_confirm_button'),
      type: 'label',
      closeAfterClick: true,
      onClick: closeCreditRefund,
    },
  });
}
